import { StyleSheet } from 'react-native';
import { DataTable } from 'react-native-paper';
import { useTranslation } from 'react-i18next';

import { withTranslation } from '../../../locales/hoc';
import { spacing } from '../../../theme';
import { Text } from '../../Text';

export const NoData = withTranslation(() => {
	const { t } = useTranslation();

	return (
		<DataTable.Row>
			<DataTable.Cell>
				<Text category="s1" align="center" style={styles.text}>
					{t('table.no-data')}
				</Text>
			</DataTable.Cell>
		</DataTable.Row>
	);
});

const styles = StyleSheet.create({
	text: {
		flex: 1,
		paddingVertical: spacing(10),
	},
});
